import React, { useState, useEffect } from 'react';

function mgiColor(score) {
  if (score >= 80) return '#059669';
  if (score >= 65) return '#0284c7';
  if (score >= 50) return '#d97706';
  if (score >= 35) return '#ea580c';
  return '#dc2626';
}

export default function RankingsPage() {
  const [allData, setAllData] = useState(null);
  const [year, setYear] = useState('2023');
  const [years, setYears] = useState([]);
  const [rankings, setRankings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('all');

  // Load all data once
  useEffect(() => {
    fetch(`${process.env.PUBLIC_URL}/data/grademygovernment_data.json`)
      .then(r => r.json())
      .then(data => {
        setAllData(data);
        setYears(Object.keys(data).sort());
        setLoading(false);
      })
      .catch(err => { console.error(err); setLoading(false); });
  }, []);

  // Compute rankings when year or data changes
  useEffect(() => {
    if (!allData || !allData[year]) return;
    const ranked = allData[year]
      .filter(c => c.mgi1 !== null && c.mgi1 !== undefined)
      .sort((a, b) => (b.mgi1 || 0) - (a.mgi1 || 0))
      .map((c, i) => ({ rank: i + 1, code: c.code, name: c.name, mgi: c.mgi1 }));
    setRankings(ranked);
  }, [allData, year]);

  const displayed = filter === 'top20'
    ? rankings.slice(0, 20)
    : filter === 'bottom20'
    ? rankings.slice(-20)
    : rankings;

  return (
    <div style={{ maxWidth: 800, margin: '0 auto', padding: '2rem 1.5rem' }}>
      <h1 style={{ fontFamily: "'Playfair Display', Georgia, serif", fontSize: '2rem', color: '#0f172a', marginBottom: '0.5rem' }}>
        Global MGI Rankings
      </h1>
      <p style={{ color: '#64748b', marginBottom: '1.5rem' }}>
        Countries ranked by Macro-Governance Index score for the selected year.
      </p>

      <div style={{ display: 'flex', gap: '1rem', marginBottom: '1.5rem', flexWrap: 'wrap' }}>
        <select value={year} onChange={e => setYear(e.target.value)}
          style={{ padding: '0.6rem 1rem', border: '2px solid #e2e8f0', borderRadius: 8, fontSize: '0.9rem' }}>
          {years.map(y => <option key={y} value={y}>{y}</option>)}
        </select>
        <div style={{ display: 'flex', gap: '0.5rem' }}>
          {[['all', 'All'], ['top20', 'Top 20'], ['bottom20', 'Bottom 20']].map(([val, lbl]) => (
            <button key={val} onClick={() => setFilter(val)}
              style={{
                padding: '0.5rem 1rem', borderRadius: 6, border: 'none', cursor: 'pointer',
                background: filter === val ? '#0f766e' : '#f1f5f9',
                color: filter === val ? '#fff' : '#475569',
                fontWeight: 600, fontSize: '0.85rem'
              }}>
              {lbl}
            </button>
          ))}
        </div>
      </div>

      {loading ? (
        <p style={{ textAlign: 'center', color: '#94a3b8', padding: '2rem' }}>Loading...</p>
      ) : (
        <div style={{ borderRadius: 12, border: '1px solid #e2e8f0', overflow: 'hidden' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.9rem' }}>
            <thead>
              <tr style={{ background: '#f8fafc' }}>
                <th style={{ padding: '0.75rem 1rem', textAlign: 'left', fontWeight: 700, color: '#475569', width: 60 }}>Rank</th>
                <th style={{ padding: '0.75rem 1rem', textAlign: 'left', fontWeight: 700, color: '#475569' }}>Country</th>
                <th style={{ padding: '0.75rem 1rem', textAlign: 'right', fontWeight: 700, color: '#475569', width: 120 }}>MGI Score</th>
              </tr>
            </thead>
            <tbody>
              {displayed.map(r => (
                <tr key={r.code} style={{ borderTop: '1px solid #f1f5f9' }}>
                  <td style={{ padding: '0.6rem 1rem', fontFamily: "'JetBrains Mono', monospace", color: '#94a3b8', fontWeight: 600 }}>
                    {r.rank}
                  </td>
                  <td style={{ padding: '0.6rem 1rem', color: '#1e293b' }}>
                    <span style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: '0.75rem', color: '#0f766e', marginRight: 8 }}>{r.code}</span>
                    {r.name}
                  </td>
                  <td style={{ padding: '0.6rem 1rem', textAlign: 'right' }}>
                    <span style={{
                      fontFamily: "'JetBrains Mono', monospace", fontWeight: 700,
                      color: mgiColor(r.mgi), fontSize: '1rem'
                    }}>
                      {r.mgi !== null ? r.mgi.toFixed(2) : '—'}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
